import React, { useState, useRef } from "react";
import AuditInventorySearch from "./audit-inventory-search.component";
import AuditInventoryGrid from "./audit-inventory-grid.component";
import * as auditInventoryServices from "./audit-inventory.services";
import * as GlobalService from "./../global_services";

import "./audit-inventory.scss";
import AuditInventorySummary from "./auditInventorySummary/audit-inventory-summary.component";
import WmsModel from "../components/WmsModel/WmsModel";
import WmsButton from "../components/WmsButton/WmsButton";
interface Props {}
declare var window: any;
var $rootScope = window;
const selector = "AuditInventory";

const AuditInventoryHolder: React.FC<Props> = (props: Props): any => {
    const [windowId] = useState($rootScope.ChildBulletin.Data.Window);
    const [filterAreaToggle, setFilterAreaToggle] = useState(false);
    const [isAnimatedClassAdded, setIsAnimatedClassAdded] = useState(false);
    const [auditDataResponse, setAuditGridData] = useState([]);
    const [locationTypes, setLocationTypes] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const facUri = useRef("");
    const [facId, setFacId] = useState(0);
    const [closejobGif, setClosejobGif] = useState(false);
    const [recordsCount, setRecordsCount] = useState<number>(0);
    const [isShowSummary, setIsShowSummary] = useState<boolean>(false);
    const [selectedAuditJobData, setSelectedAuditJobData] = useState(null);
    const [batchList, setBatchList] = useState<any[]>([]);
    const [maxPerJobDay, setMaxPerJobDay] = useState<boolean>(false);
    const [isFilterLoading, setIsFilterLoading] = useState<boolean>(false);

    const clickForFilterToggle = () => {
        setFilterAreaToggle(!filterAreaToggle);
        setIsAnimatedClassAdded(!isAnimatedClassAdded);
        setTimeout(() => {
            setIsAnimatedClassAdded((previousAnimatedClassAdded) => !previousAnimatedClassAdded);
        }, 1000);
        resizeWindow();
    };
    const facilityChange = async (facObj) => {
        const response = await GlobalService.GetCustomerFacilityListAxios();
        if (response && response.data && response.status !== 304) {
            const updatedFacObj = Object.values(response.data.facilities).find((x: any) => x.id === facObj.id);
            facObj = updatedFacObj;
        }
        if (facObj) {
            facUri.current = facObj.uri;
            setFacId(facObj.id);
            setMaxPerJobDay(facObj?.maxCycleCountsPerDayExceeded);
        } else {
            facUri.current = "";
            setFacId(0);
            setAuditGridData([]);
            setRecordsCount(0);
        }
    };

    const getAuditOptions = async (facilityUri) => {
        const facilityId = facilityUri.split("/")[3];
        await auditInventoryServices
            .auditOptions(facilityUri)
            .then((response) => {
                setAuditGridData(response.data.Audits);
                processAuditOptions(response.data);
            })
            .finally(() => {
                setIsFilterLoading(false);
            });

        auditInventoryServices.getOpenBatchs(facilityId).then((response: any) => {
            if (response.data) {
                setBatchList([{ Name: "", Value: 0 }, ...response.data]);
            } else {
                setBatchList([]);
            }
        });
    };
    const getBlankAuditOptions = (facilityUri) => {
        auditInventoryServices
            .blankAuditOptions(facilityUri)
            .then((response) => {
                setAuditGridData([]);
                processAuditOptions(response.data);
            })
            .finally(() => {
                setIsFilterLoading(false);
            });
    };
    const processAuditOptions = (data) => {
        data.Users.unshift({
            Id: 0,
            Name: "Unspecified",
        });
        setUserOptions(data.Users);

        data.LocationTypes.unshift({
            Value: 0,
            Name: "All",
        });
        setLocationTypes(data.LocationTypes);
    };
    const searchApiCallback = () => {
        (async () => {
            setRecordsCount(0);
            setIsFilterLoading(true);
            const countRes = await auditInventoryServices.getTotalAuditOptionsCount(facUri.current);
            setRecordsCount(countRes.data);
            if (countRes.data > 0 && countRes.data < auditInventoryServices.gridPageSize) {
                getAuditOptions(facUri.current);
            } else {
                getBlankAuditOptions(facUri.current);
            }
        })();
    };

    const resizeWindow = () => {
        $(window).trigger("resize");
    };

    const closeJob = (auditUris) => {
        setClosejobGif(true);
        auditInventoryServices
            .closeJob(auditUris)
            .then((response) => {
                GlobalService.notification("success", window.translate("Label_Close_job_success"));
                getAuditOptions(facUri.current);
                setClosejobGif(false);
            })
            .catch(() => {
                setClosejobGif(false);
            });
    };

    const openSummary = () => {
        setFilterAreaToggle(true);
        setIsShowSummary(true);
    };

    const setSelectedAuditJob = (selectedAuditJobData: any) => {
        setSelectedAuditJobData(selectedAuditJobData);
    };

    const onExitAuditSummary = () => {
        setFilterAreaToggle(false);
        setIsShowSummary(false);
        setSelectedAuditJobData(null);
    };

    const onCloseMaxPerJobDayModal = () => {
        setMaxPerJobDay(false);
    };

    return (
        <div
            id="audit-inventory-beta-holder-react"
            className={
                (filterAreaToggle ? " collapsedFilter " : " expandFilter ") +
                (isAnimatedClassAdded ? " animatedCollapse" : "")
            }
        >
            <AuditInventorySearch
                // sharedFilterObject={}
                selector={selector}
                windowId={windowId}
                isSectionToggled={filterAreaToggle}
                showSummary={isShowSummary}
                onClickForFilterToggle={clickForFilterToggle}
                OnFacilitySelect={facilityChange}
                userOptions={userOptions}
                onApplyFilter={searchApiCallback}
            />
            <AuditInventoryGrid
                recordsCount={recordsCount}
                selector={selector}
                auditGridData={auditDataResponse}
                windowId={windowId}
                userOptions={userOptions}
                locationTypes={locationTypes}
                facId={facId}
                facUri={facUri.current}
                getAuditOptions={getAuditOptions}
                closeJob={closeJob}
                closejobGif={closejobGif}
                onRefreshGrid={searchApiCallback}
                onSummaryClick={openSummary}
                setSelectedAuditJob={setSelectedAuditJob}
                batchList={batchList}
                isFilterLoading={isFilterLoading}
            />
            {isShowSummary && (
                <div className="audit-inventory-summary-holder">
                    <AuditInventorySummary
                        facId={facId}
                        selector={selector}
                        isShowSummary={isShowSummary}
                        onExitAuditSummary={onExitAuditSummary}
                        selectedAuditJob={selectedAuditJobData}
                    />
                </div>
            )}

            {maxPerJobDay && (
                <WmsModel
                    id="maxPerJobDayModal"
                    title={window.translate("Label_Warning")}
                    width={800}
                    onCloseFunc={onCloseMaxPerJobDayModal}
                    isOpen={maxPerJobDay}
                    customClass="wms-model-new-ui-wrapper"
                    actions={[]}
                    overlayHide={false}
                    windowId={windowId}
                    appendTo={"#" + windowId}
                >
                    <div className="model-content-wrapper">
                        <p dangerouslySetInnerHTML={{ __html: window.translate("Label_Max_Per_Job_Day_Warning") }} />
                        <p
                            dangerouslySetInnerHTML={{
                                __html: window.translate("Label_Max_Per_Job_Day_Warning_Description"),
                            }}
                        />
                    </div>
                    <div className="footer-btn-holder">
                        <WmsButton
                            label={window.translate("Label_Close")}
                            wmsSelector={selector + "CloseBtn"}
                            onClickFunc={onCloseMaxPerJobDayModal}
                            buttonType="orange"
                            icon={"fa-regular fa-circle-xmark"}
                        />
                    </div>
                </WmsModel>
            )}
        </div>
    );
};
AuditInventoryHolder.propTypes = {};

export default React.memo(AuditInventoryHolder);
